import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import '../css/getCombo.css';
class getCombo extends Component {
  constructor(props){
    super(props)
    this.state = {
        id_producto_combo : this.props.id_producto_combo,
        complemento : [],
        cantidad_complemento:[],
        sw_paso:0,
        id_index:this.props.id_index,
        lista_items_adicional :this.props.lista_items_adicional,
        precio_combo:this.props.precio_combo,
        sw_iva:this.props.sw_iva,
        title:this.props.title
    }
  }
  getConfiguracionCombo =()=>{
    const url= this.props.dir_url + "webapp/getDataCombo";
    const token =  this.props.token
    const id_producto = this.state.id_producto_combo
    var obj = { accion:'datacomplementos', token, id_producto};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){

        const id_index = this.state.id_index
        var cantidad_complemento = this.state.cantidad_complemento.slice();
        if(Number(id_index)===-1){
          const complemento = data[0].msg.filter(complemento => complemento.complemento === "Combo")
          complemento.forEach(cp => {
            cp.CDetalle.forEach(cp_detalle => {
                cantidad_complemento[cp_detalle.id_complemento] = Number(cp_detalle.defecto)
            })
          })
        }else{
          const lista_items_adicional = this.state.lista_items_adicional
          lista_items_adicional.forEach((cp,index) => {
            if(Number(id_index)===Number(index)){
              cp.complemento_final.forEach(cp_detalle => {
                  if(cp_detalle.complemento==='Combo'){
                    cp_detalle.CDetalle.forEach(cp_detalle_combo => {
                      cantidad_complemento[cp_detalle_combo.id_complemento] = Number(cp_detalle_combo.cant)
                    })
                  }else{
                    cantidad_complemento[cp_detalle.id_complemento] = Number(cp_detalle.cant)
                  }
              })
            }
          })
        }

        this.setState({
          cantidad_complemento,
          complemento:data[0].msg
        },()=>{
          this.getValidarCombo()
        })
      }
    })
    .catch(console.log)
  }
  //complemento, id_complemento, producto, id_productos, etiqueta, maximo, precio, defecto
  getValidarCantidad =(id_complemento)=>{
    let continuar = false
    const complemento = this.state.complemento.filter(complemento => complemento.complemento === "Combo")
    var cantidad_complemento = this.state.cantidad_complemento.slice();
    complemento.forEach(cp => {
        let cantidad_maxima = Number(cp.maximo)
        let cantidad_inicial =0
        let sw_encontro_complemento =0
        cp.CDetalle.forEach(cp_detalle => {
            if(Number(cp_detalle.id_complemento)===Number(id_complemento)){
              sw_encontro_complemento=1
            }
            if(isNaN(cantidad_complemento[cp_detalle.id_complemento])){
            }else{
              cantidad_inicial = cantidad_inicial + Number(cantidad_complemento[cp_detalle.id_complemento])
            }
        })
        if(sw_encontro_complemento===1){
          if(cantidad_maxima>0){
            if(cantidad_inicial<cantidad_maxima){
               continuar = true
               return
            }
          }else{
            continuar = true
            return
          }
        }
    })
    return continuar
  }
  getValidarCombo=()=>{
    const complemento = this.state.complemento.filter(complemento => complemento.complemento === "Combo")
    var cantidad_complemento = this.state.cantidad_complemento.slice();

    let sw_paso = 1
    let sw_combo =0
    complemento.forEach(cp => {
        let cantidad_maxima = Number(cp.maximo)
        let cantidad_inicial =0
        sw_combo=1
        cp.CDetalle.forEach(cp_detalle => {
            if(isNaN(cantidad_complemento[cp_detalle.id_complemento])){

            }else{
              cantidad_inicial = cantidad_inicial + Number(cantidad_complemento[cp_detalle.id_complemento])
            }
        })
        if(cantidad_inicial!==cantidad_maxima && cantidad_maxima!==0){
          sw_paso = 0
        }else{

        }
    })
    if(sw_combo==1){
      this.setState({
        sw_paso
      })
      return
    }
    if(this.state.cantidad_complemento.length===0){
      sw_paso = 0
      //console.log("-->")
    }else{
      const complement_item = this.state.complemento.filter(complement_item => (complement_item.complemento === "Adicional"))//complement_item.complemento === "Combo"||
      //console.log(complement_item)
      //console.log(cantidad_complemento)
      let contador =0
      complement_item.forEach(cp => {
        //console.log(cp)
        if(!isNaN(cantidad_complemento[cp.id_complemento])){
          if(Number(cantidad_complemento[cp.id_complemento])>0){
            contador++
            //console.log("-->"+contador)
          }
        }
      })
      if(contador===0){
        sw_paso = 0
      }
    }
    //console.log(sw_paso)


    this.setState({
      sw_paso
    })
  }
  eliminarCantidad = (index) => {
    var cantidad_complemento = this.state.cantidad_complemento.slice();
    if(isNaN(cantidad_complemento[index])){
      cantidad_complemento[index] = "";
    }else{
      cantidad_complemento[index] = Number(cantidad_complemento[index]) - 1;
      if(cantidad_complemento[index]<=0){
        cantidad_complemento[index] = "";
      }
    }
    this.setState({
      cantidad_complemento
    },()=>{
      this.getValidarCombo()
    })
  }

  agregarCantidad =(index)=>{
    if(this.getValidarCantidad(index)){
      var cantidad_complemento = this.state.cantidad_complemento.slice();
      if(isNaN(cantidad_complemento[index])){
        cantidad_complemento[index] = 1;
      }else{
        cantidad_complemento[index] = Number(cantidad_complemento[index]) + 1;
      }
      this.setState({
        cantidad_complemento
      },()=>{
        this.getValidarCombo()
      })
    }
  }
  agregarCantidadAdicional =(index)=>{
    //if(this.getValidarCantidad(index)){
      var cantidad_complemento = this.state.cantidad_complemento.slice();
      if(isNaN(cantidad_complemento[index])){
        cantidad_complemento[index] = 1;
      }else{
        cantidad_complemento[index] = Number(cantidad_complemento[index]) + 1;
      }
      this.setState({
        cantidad_complemento
      },()=>{
        this.getValidarCombo()
      })
    //}
  }

  agregarCantidadCheck =(index)=>{
    var cantidad_complemento = this.state.cantidad_complemento.slice();
    if(isNaN(cantidad_complemento[index])){
      cantidad_complemento[index] = 1
    }else{
      if(Number(cantidad_complemento[index])===0){
        cantidad_complemento[index] = 1
      }else{
        cantidad_complemento[index] = 0
      }
    }
    this.setState({
      cantidad_complemento
    })
  }

  get_to_go_salir =()=>{
    this.props.salir_prefencias()
  }

  get_to_go_continuar =()=>{

    let complemento_final = []
    let precio_adicional = 0;//Number(this.state.precio_adicional)
    const complemento = this.state.complemento
    var cantidad_complemento = this.state.cantidad_complemento.slice();
    complemento.forEach(cp => {
      if(cp.complemento==='Combo'){
        let detalle_complemento =[]
        cp.CDetalle.forEach(cp_detalle => {
            if(isNaN(cantidad_complemento[cp_detalle.id_complemento])){

            }else{
              if(cantidad_complemento[cp_detalle.id_complemento]>0){
                let descuento = 0
                let precio_sub = Number(cp_detalle.precio)
                if(Number(cantidad_complemento[cp_detalle.id_complemento])>=Number(cp_detalle.cant_minima)&&Number(cp_detalle.cant_minima)>0&&Number(cp_detalle.porc_descuento)>0){
                  descuento = ((precio_sub*Number(cp_detalle.porc_descuento))/100).toFixed(4)
                  precio_sub = (precio_sub - descuento).toFixed(2)
                }

                detalle_complemento=[...detalle_complemento, {
                  'complemento': cp_detalle.complemento,
                  'id_complemento': cp_detalle.id_complemento,
                  'producto': cp_detalle.producto,
                  'id_productos': cp_detalle.id_productos,
                  'etiqueta': cp_detalle.etiqueta,
                  'maximo': cp_detalle.maximo,
                  'precio': cp_detalle.precio,
                  'defecto': cp_detalle.defecto,
                  'cant': cantidad_complemento[cp_detalle.id_complemento]
                 }]
                 precio_adicional = precio_adicional + (precio_sub*Number(cantidad_complemento[cp_detalle.id_complemento]))
              }
            }
        })
        if(detalle_complemento.length>0){
          complemento_final=[...complemento_final, {
            'complemento': cp.complemento,
            'id_complemento': cp.id_complemento,
            'etiqueta': cp.etiqueta,
            'maximo': cp.maximo,
            'CDetalle': detalle_complemento
           }]
        }
      }else{
        if(isNaN(cantidad_complemento[cp.id_complemento])){
        }else{
          if(cantidad_complemento[cp.id_complemento]>0){

             let descuento = 0
             let precio_sub = Number(cp.precio)
             if(Number(cantidad_complemento[cp.id_complemento])>=Number(cp.cant_minima)&&Number(cp.cant_minima)>0&&Number(cp.porc_descuento)>0){
               descuento = ((precio_sub*Number(cp.porc_descuento))/100).toFixed(4)
               precio_sub = (precio_sub - descuento).toFixed(2)
             }

             complemento_final=[...complemento_final, {
               'complemento': cp.complemento,
               'id_complemento': cp.id_complemento,
               'producto': cp.producto,
               'id_productos': cp.id_productos,
               'etiqueta': cp.etiqueta,
               'maximo': cp.maximo,
               'precio': cp.precio,
               'defecto': cp.defecto,
               'descuento': descuento,
               'cant': cantidad_complemento[cp.id_complemento]
              }]

             precio_adicional = precio_adicional + (precio_sub*Number(cantidad_complemento[cp.id_complemento]))
           }
         }
      }

    })
    const id_producto_combo = this.state.id_producto_combo
    const id_index = this.props.id_index
    const sw_iva = this.state.sw_iva
    const precio_inicial=this.state.precio_combo
    this.props.agregarPreferencias(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial)
  }
  getDataCombo =()=>{

    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_60x60
    const token_image = url_image+file_xxx+separator
    const ext="_60x60.png?alt=media"

    /*<div className="grid-container-combo-cantidad" key={index}>
      <div className="lbl_combo_detalle">{combo_det.producto}</div>
      <div className="lbl_combo_cantidad">{(this.state.cantidad_complemento[combo_det.id_complemento])?this.state.cantidad_complemento[combo_det.id_complemento]+"x":""}</div>
      <div className="lbl_combo_restar">{(this.state.cantidad_complemento[combo_det.id_complemento])?
      <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(combo_det.id_complemento)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
      :''}</div>
      <div className="lbl_combo_sumar" onClick={ () => this.agregarCantidad(combo_det.id_complemento) }><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  /></div>
    </div>*/
    const combo = this.state.complemento.filter(complemento => complemento.complemento === "Combo")
    const adicional = this.state.complemento.filter(complemento => complemento.complemento === "Adicional")
    const preferencia = this.state.complemento.filter(complemento => complemento.complemento === "Preferencia")
    const sw_paso = this.state.sw_paso
    return (
      <div className="cssversion_pw100 cssversion_ph100">
        <div className="cssversion_pw100 cssversion_ph85" style={{"overflowY":"auto"}}>
        <div className="cssversion_pw100 cssversion_pxh40 cssversion_contentCenter borderBottom" style={{"borderRadius": "25px 0px 25px 0px"}}>
          <span className="cssversion_span-title-sucursal" style={{"font-size":"14pt"}}>Combo: {this.state.title}</span>
        </div>
          {(combo.length>0)?
            <React.Fragment>

              {
                combo.map((combo_sub , index) => (
                  <React.Fragment key={index}>
                    <div className="cssversion_pw100 cssversion_pxh40 cssversion_contentCenter" >
                      <span className="span-global-link"><b>{combo_sub.etiqueta}<br/> {(Number(combo_sub.maximo)>0)?'Seleccione Máximo '+combo_sub.maximo+' Producto(s)':''}</b></span>
                    </div>
                    {combo_sub.CDetalle.map((combo_det , index) => (




                      <div className="cssversion_pw100 cssversion_pxh90 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} >
                        <div className="cssversion_pw10 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            {(this.state.cantidad_complemento[combo_det.id_complemento])?this.state.cantidad_complemento[combo_det.id_complemento]+"x":""}
                          </div>
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}}  >
                            {(this.state.cantidad_complemento[combo_det.id_complemento])?
                            <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(combo_det.id_complemento)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
                            :''}
                          </div>
                        </div>
                        <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                           src={
                           ((combo_det.uuid_imagen+'').trim()==='')?
                             "https://www.grupomn.net/app/img/sinfoto.png"
                           :
                             token_image+combo_det.uuid_imagen+ext
                           }/>
                        </div>
                        <div className="cssversion_pw55 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-producto">{combo_det.producto}</span>
                            {Number(combo_det.precio)>0?
                            <span style={{"color":"red"}}> +${combo_det.precio}</span>:null}
                          </div>
                        </div>
                        <div className="cssversion_pw15 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}}  onClick={ () => this.agregarCantidad(combo_det.id_complemento) } >
                            <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  />
                          </div>
                        </div>
                      </div>






                    ))}
                  </React.Fragment>
                ))
              }
            </React.Fragment>
          :''}
          {(adicional.length>0)?
            <React.Fragment>
              <div className="cssversion_pw100 cssversion_pxh20 cssversion_contentCenter" >
                <span className="span-global-link"><b>Adicionales</b></span>
              </div>
              {
                adicional.map((adicional , index) => (
                  <div className="cssversion_pw100 cssversion_pxh90 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} >
                    <div className="cssversion_pw10 cssversion_pxh90">
                      <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                        {(this.state.cantidad_complemento[adicional.id_complemento])?this.state.cantidad_complemento[adicional.id_complemento]+"x":""}
                      </div>
                      <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}}  >
                        {(this.state.cantidad_complemento[adicional.id_complemento])?
                        <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(adicional.id_complemento)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
                        :''}
                      </div>
                    </div>
                    <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
                      <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                       src={
                       ((adicional.uuid_imagen+'').trim()==='')?
                         "https://www.grupomn.net/app/img/sinfoto.png"
                       :
                         token_image+adicional.uuid_imagen+ext
                       }/>
                    </div>
                    <div className="cssversion_pw55 cssversion_pxh90">
                      <div className="cssversion_pw100 cssversion_pxh90" >
                        <div className="cssversion_pw100 cssversion_ph50 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <span className="span-global" style={{"padding":"5px"}}>{adicional.producto}</span>
                          <span style={{"color":"red"}}>+${adicional.precio}</span>
                        </div>
                        <div className="cssversion_pw100 cssversion_ph50 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <span style={{"color":"green"}}>{adicional.observacion_adicional}</span>
                        </div>
                      </div>
                    </div>
                    <div className="cssversion_pw15 cssversion_pxh90">
                      <div className="cssversion_pw100 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}}  onClick={ () => this.agregarCantidadAdicional(adicional.id_complemento) } >
                        <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  />
                      </div>
                    </div>
                  </div>
                ))
              }
            </React.Fragment>
          :''}
          {(preferencia.length>0)?
            <React.Fragment>
              <div className="cssversion_pw100 cssversion_pxh20 cssversion_contentCenter" >
                <span className="span-global-link"><b>Preferencias</b></span>
              </div>
              {
                preferencia.map((preferencia , index) => (
                  <div className="cssversion_pw100 cssversion_pxh90 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} key={index}  onClick={ () => this.agregarCantidadCheck(preferencia.id_complemento) }>
                    <div className="cssversion_pw10 cssversion_pxh90 cssversion_contentCenter">
                      <Checkbox inputProps={{ 'aria-label': 'primary checkbox' }} checked={(this.state.cantidad_complemento[preferencia.id_complemento])?true:false}/>
                    </div>
                    <div className="cssversion_pw90 cssversion_pxh90 cssversion_contentCenter">
                      <span className="span-global" style={{"padding":"5px"}}>{preferencia.producto}</span>
                    </div>
                  </div>
                ))
              }
            </React.Fragment>
          :''}
        </div>
        <div className="cssversion_pw100 cssversion_ph15 cssversion_contentCenter">
            <button style={{"width":"48%"}} className="button-global" onClick={ () => this.get_to_go_salir()}>Regresar</button>
          <button style={{"width":"48%"}} className={(Number(sw_paso)===0)? "button-global-disabled":"button-global"} onClick={ () => this.get_to_go_continuar()} disabled={(Number(sw_paso)===0)?
          true : false} >Agregar</button>

        </div>
      </div>
    )
  }
  render() {
    return (
       <div className="cssversion_menu cssversion_colorblanco">
        {this.getDataCombo()}
       </div>
    );
  }
  componentDidMount (){
    this.getConfiguracionCombo()
  }
}
export default getCombo;

/*<div className="cssversion_pw100 cssversion_pxh90 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} key={index} onClick={ () => this.agregarCantidadCheck(adicional.id_complemento) }>
  <div className="cssversion_pw10 cssversion_pxh90 cssversion_contentCenter">
    <Checkbox inputProps={{ 'aria-label': 'primary checkbox' }} checked={(this.state.cantidad_complemento[adicional.id_complemento])?true:false}/>
  </div>
  <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter">
    <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
     src={
     ((adicional.uuid_imagen+'').trim()==='')?
       "https://www.grupomn.net/app/img/sinfoto.png"
     :
       token_image+adicional.uuid_imagen+ext
     }/>
  </div>
  <div className="cssversion_pw70 cssversion_pxh90 cssversion_contentCenter">
    <span className="span-global" style={{"padding":"5px"}}>{adicional.producto}</span> <span style={{"color":"red"}}>+${adicional.precio}</span>
  </div>
</div>*/
